import { z } from 'zod'

import { zCleanString } from '../utils'
import { SortOption } from './beneficiary'
import { Language } from './organization'

export type CaseWorkerDTO = {
  email: string
  firstName: string
  id: string
  language?: Language
  lastName: string
  role: CaseWorkerRole
  status: CaseWorkerStatus
}

export enum CaseWorkerRole {
  Admin = 'admin',
  CaseWorker = 'case-worker',
}

export enum CaseWorkerStatus {
  Disabled = 'disabled',
  Enabled = 'enabled',
  Pending = 'pending',
}

export const caseWorkerSchema = {
  email: zCleanString.email(),
  firstName: zCleanString,
  id: zCleanString,
  language: z.nativeEnum(Language).optional(),
  lastName: zCleanString,
  role: z.nativeEnum(CaseWorkerRole),
  status: z.nativeEnum(CaseWorkerStatus),
}

export type SudoContextCaseWorkerDTO = {
  firstName: string
  id: string
  lastName: string
  organizationId: string
  role: CaseWorkerRole
  status: CaseWorkerStatus
}

export const CaseWorkerIdFilter_AllBeneficiaries: string = 'ALL'

export type CaseWorkerPreferencesDTO = {
  beneficiaryListSortOption: SortOption
  beneficiaryListColumnIds: string[]
}
